import { Col, Row } from "antd";
import React, { Component } from "react";
import Images from "../../Images";
import FloatingText from "./FloatingText";
import { useMediaQuery } from "react-responsive";
import { changeFeed } from "../../../../redux/actions/appActions";
import { connect } from "react-redux";

const IsMiddleScreenAndMobile = ({ children }) => {
  const isDesktop = useMediaQuery({ maxWidth: 1100 });
  return isDesktop ? children : null;
};
const IsDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1100 });
  return isDesktop ? children : null;
};

export class HomeBanners extends Component {
  nav =(routeUrl)=>{
    const {history , changeFeed} = this.props
    history.push(`${routeUrl}`)
    // changeFeed('6', 'sport');
  }
  render() {
    const { landingBanners , history } = this.props;
    return (
      <div className="home-banners-container">
        <IsDesktop>
          <Row className="home-banners" type="flex">
            <Col md={17} className="main-img">
              {landingBanners[0] && <img src={`${landingBanners[0].bannerPath}?id=${landingBanners[0].imageVersion}`} alt="betting-image" onClick={()=>this.nav(landingBanners[0].routeUrl)}/>}
            </Col>
            <Col md={7} className="secondary-img">
              {landingBanners.slice(1).map((item) => {
                return (
                  <Row key={item.bannerId}>
                    {/* <FloatingText text={item.sportType == 2 ? `Basketball`: item.sportType == 2 ? `Football` : ``} /> */}
                    <img src={`${item.bannerPath}?id=${item.imageVersion}`} alt="soccer-image" onClick={()=>this.nav(item.routeUrl)}/>
                  </Row>
                );
              })}
            </Col>
          </Row>
        </IsDesktop>
        <IsMiddleScreenAndMobile>
          <Row className="mobile-home-banners" type="flex">
            {landingBanners && <img
              src={`${landingBanners[0].bannerPath}?id=${landingBanners[0].imageVersion}`}
              alt="betting-image"
              className="mobile-banner-images"
              onClick={()=>this.nav(landingBanners[0].routeUrl)}
            />}
          </Row>
          <Row className="mobile-home-banners" type="flex">
            {landingBanners.slice(1).map((item) => {
              return (
                <Col span={12} key={item.bannerId}>
                  <img
                    src={`${item.bannerPath}?id=${item.imageVersion}`}
                    alt="soccer-image"
                    className="mobile-banner-images"
                    onClick={()=>this.nav(item.routeUrl)}
                  />
                </Col>
              );
            })}
          </Row>
        </IsMiddleScreenAndMobile>
      </div>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeFeed: (feedId, feedName) => dispatch(changeFeed(feedId, feedName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeBanners);

